var _style, _rect, _path, _path2, _path3, _path4, _rect2, _rect3, _rect4, _path5, _path6, _rect5, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClient04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 595.2 75",
    style: {
      enableBackground: "new 0 0 595.2 75"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:rgba(255,255,255,0.75);}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40.1,
    y: 32.8,
    className: "st0",
    width: 40.1,
    height: 9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100.2,0H73.7l6.4,9.1L99.5,15c3.6,1.1,5.9,4.5,5.8,8c0,0,0,0,0,0V52c0,0,0,0,0,0c0,3.6-2.3,6.9-5.8,8 l-19.3,5.9L73.7,75h26.5c11.1,0,20-9,20-20V20C120.3,9,111.3,0,100.2,0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20,0h26.5l-6.4,9.1L20.8,15c-3.6,1.1-5.9,4.5-5.8,8c0,0,0,0,0,0V52c0,0,0,0,0,0c0,3.6,2.3,6.9,5.8,8l19.3,5.9 l6.4,9.1H20C9,75,0,66,0,55V20C0,9,9,0,20,0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M444.9,52.4c0,6.5-5.3,11.7-11.9,11.7c-6.6,0-11.9-5.3-11.9-11.7V23.7c0-6.5,5.3-11.7,11.9-11.7 c6.5,0,11.9,5.3,11.9,11.7V24h9.1v-0.4C454,12.3,444.6,3,433,3s-21,9.3-21,20.7v28.6c0,11.4,9.4,20.7,21,20.7 c11.5,0,20.9-9.3,21-20.7V52h-9.1V52.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M492.1,21.5c-9.6,0-17.6,7.5-18,17v17.6c0.5,9.5,8.4,17,18,17c9.6,0,17.5-7.5,18-17V38.5 C509.7,29,501.8,21.5,492.1,21.5 M501,55c-0.1,5-4,8.9-8.9,8.9c-4.9,0-8.8-3.9-8.9-8.9V39.5c0-4.9,4-8.9,8.9-8.9 c4.9,0,8.9,4,8.9,8.9V55z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 458.5,
    y: 3,
    className: "st0",
    width: 9.1,
    height: 69
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 208.8,
    y: 21.5,
    className: "st0",
    width: 9.1,
    height: 50.4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 190.7,
    y: 3,
    className: "st0",
    width: 9.1,
    height: 69
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M167.8,3h-11.1l-18.3,68.9l0,0.1h9l4.9-18.3l20,0.1l4.8,18.2l0,0.1h9L167.8,3L167.8,3z M169.9,44.7h-15.2 l7.6-28.6L169.9,44.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M543.6,56c0,4.9-4,8.9-8.9,8.9c-4.9,0-8.9-4-8.9-8.9V21.5h-9.1v36c0,8.6,7,15.6,15.6,15.6 c1.6,0,3.1-0.2,4.6-0.7c0.9-0.3,1.7-0.6,2.5-1c1.4-0.7,2.7-1.6,3.8-2.7l0.4-0.4v3.7h9.1V21.5h-9.1V56z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 208.8,
    y: 3,
    className: "st0",
    width: 9.1,
    height: 9.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M247.3,21.5c-4.1,0-8,1.6-10.9,4.5l-0.4,0.4V3h-9.1v69h9.1v-3.7l0.4,0.4c2.9,2.9,6.8,4.5,10.9,4.5 c8.6,0,15.6-7,15.6-15.6V37.1C262.9,28.4,255.9,21.5,247.3,21.5 M253.9,38.7v17.1c0,4.9-4,9-9,9c-4.9,0-9-4-9-9V38.7c0-4.9,4-9,9-9 C249.9,29.8,253.9,33.8,253.9,38.7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M331.7,21.4c-4.1,0-8,1.6-10.9,4.5l-0.4,0.4V3h-9.1v69h9.1v-3.7l0.4,0.4c2.9,2.9,6.8,4.5,10.9,4.5 c8.6,0,15.6-7,15.6-15.6V37C347.3,28.4,340.3,21.4,331.7,21.4 M338.3,38.7v17.1c0,4.9-4,9-9,9c-4.9,0-9-4-9-9V38.7c0-4.9,4-9,9-9 C334.3,29.7,338.3,33.8,338.3,38.7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M586.2,3v23.3l-0.4-0.4c-2.9-2.9-6.8-4.5-10.9-4.5c-8.6,0-15.6,7-15.6,15.6v20.4l0,0.1c0,8.6,7,15.5,15.6,15.5 c4.1,0,8-1.6,10.9-4.5l0.4-0.4v3.7h9.1V3H586.2z M586.1,38.7v17.1c0,4.9-4,9-9,9c-4.9,0-9-4-9-9V38.7c0-4.9,4-9,9-9 C582.1,29.7,586.1,33.8,586.1,38.7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M304.8,38.6c0-0.5-0.1-1.1-0.2-1.8l0-0.2c-0.5-2.7-1.5-5.3-3.1-7.6c-3.2-4.5-8.1-7.2-13.5-7.5c-0.1,0-0.7,0-1,0 c-4.2,0-8.3,1.5-11.6,4.2c-3.2,2.7-5.4,6.4-6.2,10.6l0,0.1h8.9l0-0.1c0.8-4.2,4.5-7.2,8.7-7.2c2.3,0,4.5,0.9,6.2,2.5 c1.7,1.6,2.6,3.8,2.7,6.1l0,4.2h-12.9c-8.6,0-15.6,7-15.6,15.6c0,7.2,5,13.3,11.7,15.1c0.1,0,0.2,0,0.2,0.1c0.3,0.1,0.6,0.1,0.9,0.2 c0.3,0.1,0.7,0.1,1.1,0.2c0.1,0,0.1,0,0.2,0c0.7,0.1,1.5,0.1,2.4,0.1c2.2,0,4.1-0.3,5.4-0.8c2.3-0.7,4.4-2,6.2-3.7l0.4-0.4v3.7h9.1 v-6V38.6z M284.6,48.7h11v6.4c0,4.8-3.5,9-8.2,9.9c-0.7,0.2-1.4,0.2-2,0.2c-1.6,0-3.1-0.4-4.6-1.3c-0.4-0.2-0.8-0.5-1.2-0.7 c-0.5-0.4-1-0.9-1.4-1.4l-0.1-0.1c-1.1-1.4-1.7-3.1-1.7-4.9C276.5,52.3,280.1,48.7,284.6,48.7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M389.3,38.6c0-0.5-0.1-1.1-0.2-1.8l0-0.2c-0.5-2.7-1.5-5.3-3.1-7.6c-3.2-4.5-8.1-7.2-13.5-7.5c-0.1,0-0.7,0-1,0 c-4.2,0-8.3,1.5-11.6,4.2c-3.2,2.7-5.4,6.4-6.2,10.6l0,0.1h8.9l0-0.1c0.8-4.2,4.5-7.2,8.7-7.2c2.3,0,4.5,0.9,6.2,2.5 c1.7,1.6,2.6,3.8,2.7,6.1l0,4.2h-12.9c-8.6,0-15.6,7-15.6,15.6c0,7.2,5,13.3,11.7,15.1c0.1,0,0.2,0,0.2,0.1c0.3,0.1,0.6,0.1,0.9,0.2 c0.3,0.1,0.7,0.1,1.1,0.2c0.1,0,0.1,0,0.2,0c0.7,0.1,1.5,0.1,2.4,0.1c2.2,0,4.1-0.3,5.4-0.8c2.3-0.7,4.4-2,6.2-3.7l0.4-0.4v3.7h9.1 v-6V38.6z M369.1,48.7h11v6.4c0,4.8-3.5,9-8.2,9.9c-0.7,0.2-1.4,0.2-2,0.2c-1.6,0-3.1-0.4-4.6-1.3c-0.4-0.2-0.8-0.5-1.2-0.7 c-0.5-0.4-1-0.9-1.4-1.4l-0.1-0.1c-1.1-1.4-1.7-3.1-1.7-4.9C361,52.4,364.6,48.7,369.1,48.7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClient04);
export default __webpack_public_path__ + "static/media/client-04.a0f0b7cb6d17e3c10487bca675222574.svg";
export { ForwardRef as ReactComponent };